import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { TypographyH2 } from '~/core/ui/Heading'
import { TypographyText } from '~/core/ui/Text'
import { cn } from '~/core/ui/utils'
import LPContainer from './LPContainer'

const ApplicantTrackingCRMWorkEfficientlySection: FCC<{
  className?: string
}> = ({ className }) => {
  const { t } = useTranslation()
  const [switchTabs, setSwitchTabs] = useState('option-1')

  return (
    <div
      className={`overflow-hidden my-[100px] tablet:my-[164px] ${className}`}>
      <LPContainer>
        <div className="flex-1 flex flex-col justify-center max-w-3xl mx-auto items-center text-center">
          <div className="flex items-center relative">
            <TypographyH2 className="mt-3 mb-4 text-center text-2xl tablet:text-4.5xl font-normal flex items-center">
              {t('applicant_tracking_crm:work_efficiently:title')}
              <div className="relative w-[80px] inline-block pl-2.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="61"
                  height="46"
                  viewBox="0 0 61 46"
                  fill="none">
                  <g clip-path="url(#clip0_5870_135688)">
                    <rect
                      x="0.5"
                      width="60"
                      height="46"
                      rx="8"
                      fill="url(#paint0_linear_5870_135688)"
                    />
                    <path
                      d="M4.86364 21.2219L6.22727 18.0519L9.22727 16.611L6.22727 15.17L4.86364 12L3.5 15.17L0.5 16.611L3.5 18.0519L4.86364 21.2219ZM15.7727 33.902L18.5 27.562L24.5 24.6801L18.5 21.7983L15.7727 15.4582L13.0455 21.7983L7.04546 24.6801L13.0455 27.562L15.7727 33.902Z"
                      fill="#AC98FF"
                      fill-opacity="0.37"
                    />
                    <path
                      d="M7.59091 38.83L6.22727 42L4.86364 38.83L1.86364 37.389L4.86364 35.9481L6.22727 32.7781L7.59091 35.9481L10.5909 37.389L7.59091 38.83Z"
                      fill="#AC98FF"
                      fill-opacity="0.37"
                    />
                    <path
                      d="M57.9091 14.3158L56.9432 12.1447L54.8182 11.1579L56.9432 10.1711L57.9091 8L58.875 10.1711L61 11.1579L58.875 12.1447L57.9091 14.3158ZM50.1818 23L48.25 18.6579L44 16.6842L48.25 14.7105L50.1818 10.3684L52.1136 14.7105L56.3636 16.6842L52.1136 18.6579L50.1818 23ZM50.1818 19.1711L50.9545 17.4737L52.6159 16.6842L50.9545 15.8947L50.1818 14.1974L49.4091 15.8947L47.7477 16.6842L49.4091 17.4737L50.1818 19.1711Z"
                      fill="#AC98FF"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_5870_135688"
                      x1="4.78572"
                      y1="4.70454"
                      x2="58.6974"
                      y2="27.2618"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#5D5AF9" />
                      <stop offset="1" stop-color="#8859F6" />
                    </linearGradient>
                    <clipPath id="clip0_5870_135688">
                      <rect
                        x="0.5"
                        width="60"
                        height="46"
                        rx="8"
                        fill="white"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <TypographyText className="absolute top-0 left-0 right-0 bottom-0 text-white text-4.5xl">
                  {t('applicant_tracking_crm:work_efficiently:title01')}
                </TypographyText>
              </div>
            </TypographyH2>
          </div>
          <div
            className="text-[19px] lead-[28px]"
            dangerouslySetInnerHTML={{
              __html: `${t('applicant_tracking_crm:work_efficiently:description')}`
            }}
          />
        </div>

        <div className="mt-[63px]">
          <div className="flex tablet:space-x-[22px] space-x-3 tablet:overflow-x-hidden overflow-x-auto">
            <div className="flex-1 min-w-[135px] [&>div:last-child]:hover:bg-[#5081F0]">
              <div
                className="flex tablet:flex-row flex-col mb-4 tablet:space-x-4 min-h-[80px] cursor-pointer space-y-2 tablet:space-y-0"
                onClick={() => setSwitchTabs('option-1')}>
                <div className="tablet:w-[48px] w-[28px] tablet:h-[48px] h-[28px] [&>svg]:w-[14px] tablet:[&>svg]:w-[24px] rounded tablet:rounded-xl bg-white border-[#EBEFF6] border flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.38626 2.51126C4.91371 1.98382 5.62908 1.6875 6.375 1.6875H13.875H14.3438C14.5924 1.6875 14.8308 1.78627 15.0067 1.96209L20.1629 7.11834C20.3387 7.29415 20.4375 7.53261 20.4375 7.78125V8.25V19.5C20.4375 20.2459 20.1412 20.9613 19.6137 21.4887C19.0863 22.0162 18.3709 22.3125 17.625 22.3125H6.375C5.62908 22.3125 4.91371 22.0162 4.38626 21.4887C3.85882 20.9613 3.5625 20.2459 3.5625 19.5V4.5C3.5625 3.75408 3.85882 3.03871 4.38626 2.51126ZM6.375 3.5625H12.9375V8.25C12.9375 8.76777 13.3572 9.1875 13.875 9.1875H18.5625V19.5C18.5625 19.7486 18.4637 19.9871 18.2879 20.1629C18.1121 20.3387 17.8736 20.4375 17.625 20.4375H6.375C6.12636 20.4375 5.8879 20.3387 5.71209 20.1629C5.53627 19.9871 5.4375 19.7486 5.4375 19.5V4.5C5.4375 4.25136 5.53627 4.0129 5.71209 3.83709C5.8879 3.66127 6.12636 3.5625 6.375 3.5625ZM14.8125 7.3125H17.7054L14.8125 4.41957V7.3125ZM8.25 12C7.73223 12 7.3125 12.4197 7.3125 12.9375C7.3125 13.4553 7.73223 13.875 8.25 13.875H15.75C16.2678 13.875 16.6875 13.4553 16.6875 12.9375C16.6875 12.4197 16.2678 12 15.75 12H8.25ZM7.3125 16.6875C7.3125 16.1697 7.73223 15.75 8.25 15.75H15.75C16.2678 15.75 16.6875 16.1697 16.6875 16.6875C16.6875 17.2053 16.2678 17.625 15.75 17.625H8.25C7.73223 17.625 7.3125 17.2053 7.3125 16.6875ZM8.25 8.25C7.73223 8.25 7.3125 8.66973 7.3125 9.1875C7.3125 9.70527 7.73223 10.125 8.25 10.125H10.125C10.6428 10.125 11.0625 9.70527 11.0625 9.1875C11.0625 8.66973 10.6428 8.25 10.125 8.25H8.25Z"
                      fill="#6B7280"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <TypographyText
                    className={cn(
                      'font-medium tablet:text-xl text-lg',
                      switchTabs === 'option-1'
                        ? 'text-gray-900'
                        : 'text-gray-400'
                    )}>
                    {t(
                      'applicant_tracking_crm:work_efficiently:work_efficiently01_title'
                    )}
                  </TypographyText>
                  <TypographyText
                    className={cn(
                      'font-normal tablet:text-lg text-sm',
                      switchTabs === 'option-1'
                        ? 'text-gray-900'
                        : 'text-gray-400'
                    )}>
                    {t(
                      'applicant_tracking_crm:work_efficiently:work_efficiently01_description'
                    )}
                  </TypographyText>
                </div>
              </div>
              <div
                className={cn(
                  'h-px w-full',
                  switchTabs === 'option-1' ? 'bg-[#5081F0]' : 'bg-transparent'
                )}
              />
            </div>
            <div className="flex-1 min-w-[135px] [&>div:last-child]:hover:bg-[#5081F0]">
              <div
                className="flex tablet:flex-row flex-col mb-4 tablet:space-x-4 min-h-[80px] cursor-pointer space-y-2 tablet:space-y-0"
                onClick={() => setSwitchTabs('option-2')}>
                <div className="tablet:w-[48px] w-[28px] tablet:h-[48px] h-[28px] [&>svg]:w-[14px] tablet:[&>svg]:w-[24px] rounded tablet:rounded-xl bg-white border-[#EBEFF6] border flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.3371 2.89959C11.7032 2.53347 12.2968 2.53347 12.6629 2.89959L17.3504 7.58709C17.7165 7.9532 17.7165 8.5468 17.3504 8.91291C16.9843 9.27903 16.3907 9.27903 16.0246 8.91291L12.9375 5.82582V14.9464C12.9375 15.3902 12.5178 15.75 12 15.75C11.4822 15.75 11.0625 15.3902 11.0625 14.9464V5.82582L7.97541 8.91291C7.6093 9.27903 7.0157 9.27903 6.64959 8.91291C6.28347 8.5468 6.28347 7.9532 6.64959 7.58709L11.3371 2.89959ZM3.5625 13.875C4.08027 13.875 4.5 14.2947 4.5 14.8125V18.5625C4.5 18.8111 4.59877 19.0496 4.77459 19.2254C4.9504 19.4012 5.18886 19.5 5.4375 19.5H18.5625C18.8111 19.5 19.0496 19.4012 19.2254 19.2254C19.4012 19.0496 19.5 18.8111 19.5 18.5625V14.8125C19.5 14.2947 19.9197 13.875 20.4375 13.875C20.9553 13.875 21.375 14.2947 21.375 14.8125V18.5625C21.375 19.3084 21.0787 20.0238 20.5512 20.5512C20.0238 21.0787 19.3084 21.375 18.5625 21.375H5.4375C4.69158 21.375 3.97621 21.0787 3.44876 20.5512C2.92132 20.0238 2.625 19.3084 2.625 18.5625V14.8125C2.625 14.2947 3.04473 13.875 3.5625 13.875Z"
                      fill="#6B7280"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <TypographyText
                    className={cn(
                      'font-medium tablet:text-xl text-lg',
                      switchTabs === 'option-2'
                        ? 'text-gray-900'
                        : 'text-gray-400'
                    )}>
                    {t(
                      'applicant_tracking_crm:work_efficiently:work_efficiently02_title'
                    )}
                  </TypographyText>
                  <TypographyText
                    className={cn(
                      'font-normal tablet:text-lg text-sm',
                      switchTabs === 'option-2'
                        ? 'text-gray-900'
                        : 'text-gray-400'
                    )}>
                    {t(
                      'applicant_tracking_crm:work_efficiently:work_efficiently02_description'
                    )}
                  </TypographyText>
                </div>
              </div>
              <div
                className={cn(
                  'h-px w-full',
                  switchTabs === 'option-2' ? 'bg-[#5081F0]' : 'bg-transparent'
                )}
              />
            </div>
            <div className="flex-1 min-w-[135px] [&>div:last-child]:hover:bg-[#5081F0]">
              <div
                className="flex tablet:flex-row flex-col mb-4 tablet:space-x-4 min-h-[80px] cursor-pointer space-y-2 tablet:space-y-0"
                onClick={() => setSwitchTabs('option-3')}>
                <div className="tablet:w-[48px] w-[28px] tablet:h-[48px] h-[28px] [&>svg]:w-[14px] tablet:[&>svg]:w-[24px] rounded tablet:rounded-xl bg-white border-[#EBEFF6] border flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.75 2.625C15.75 2.10723 15.3303 1.6875 14.8125 1.6875C14.2947 1.6875 13.875 2.10723 13.875 2.625V4.5C13.875 5.01777 14.2947 5.4375 14.8125 5.4375C15.3303 5.4375 15.75 5.01777 15.75 4.5V2.625ZM15.75 13.875C15.75 13.3572 15.3303 12.9375 14.8125 12.9375C14.2947 12.9375 13.875 13.3572 13.875 13.875V15.75C13.875 16.2678 14.2947 16.6875 14.8125 16.6875C15.3303 16.6875 15.75 16.2678 15.75 15.75V13.875ZM7.3125 9.1875C7.3125 8.66973 7.73223 8.25 8.25 8.25H10.125C10.6428 8.25 11.0625 8.66973 11.0625 9.1875C11.0625 9.70527 10.6428 10.125 10.125 10.125H8.25C7.73223 10.125 7.3125 9.70527 7.3125 9.1875ZM19.5 8.25C18.9822 8.25 18.5625 8.66973 18.5625 9.1875C18.5625 9.70527 18.9822 10.125 19.5 10.125H21.375C21.8928 10.125 22.3125 9.70527 22.3125 9.1875C22.3125 8.66973 21.8928 8.25 21.375 8.25H19.5ZM16.7746 11.1496C17.1407 10.7835 17.7343 10.7835 18.1005 11.1496L19.2255 12.2746C19.5916 12.6407 19.5916 13.2343 19.2255 13.6005C18.8593 13.9666 18.2658 13.9666 17.8996 13.6005L16.7746 12.4755C16.4085 12.1093 16.4085 11.5157 16.7746 11.1496ZM19.2255 6.10041C19.5916 5.7343 19.5916 5.1407 19.2255 4.77459C18.8593 4.40847 18.2658 4.40847 17.8996 4.77459L16.7746 5.89959C16.4085 6.2657 16.4085 6.8593 16.7746 7.22541C17.1407 7.59153 17.7343 7.59153 18.1005 7.22541L19.2255 6.10041ZM12.6629 11.3371C13.029 11.7032 13.029 12.2968 12.6629 12.6629L4.22541 21.1004C3.8593 21.4665 3.2657 21.4665 2.89959 21.1004C2.53347 20.7343 2.53347 20.1407 2.89959 19.7746L11.3371 11.3371C11.7032 10.971 12.2968 10.971 12.6629 11.3371ZM11.7254 4.77459C11.3593 4.40847 10.7657 4.40847 10.3996 4.77459C10.0335 5.1407 10.0335 5.7343 10.3996 6.10041L11.5246 7.22541C11.8907 7.59153 12.4843 7.59153 12.8504 7.22541C13.2165 6.8593 13.2165 6.2657 12.8504 5.89959L11.7254 4.77459Z"
                      fill="#6B7280"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <TypographyText
                    className={cn(
                      'font-medium tablet:text-xl text-lg',
                      switchTabs === 'option-3'
                        ? 'text-gray-900'
                        : 'text-gray-400'
                    )}>
                    {t(
                      'applicant_tracking_crm:work_efficiently:work_efficiently03_title'
                    )}
                  </TypographyText>
                  <TypographyText
                    className={cn(
                      'font-normal tablet:text-lg text-sm',
                      switchTabs === 'option-3'
                        ? 'text-gray-900'
                        : 'text-gray-400'
                    )}>
                    {t(
                      'applicant_tracking_crm:work_efficiently:work_efficiently03_description'
                    )}
                  </TypographyText>
                </div>
              </div>
              <div
                className={cn(
                  'h-px w-full',
                  switchTabs === 'option-3' ? 'bg-[#5081F0]' : 'bg-transparent'
                )}
              />
            </div>
          </div>
          <div className="h-px bg-[#E3E6EC] w-full" />

          <div className="mt-[45px]">
            <div className={switchTabs === 'option-1' ? '' : 'hidden'}>
              <img
                src={
                  '/img/feature/applicant-tracking-crm/work-efficiently-01.png'
                }
                alt="work-efficiently-01"
                className="h-auto w-full hidden tablet:block"
              />
              <img
                src={
                  '/img/feature/applicant-tracking-crm/work-efficiently-01-mobile.png'
                }
                alt="work-efficiently-01"
                className="h-auto w-full tablet:hidden"
              />
            </div>
            <div className={switchTabs === 'option-2' ? '' : 'hidden'}>
              <img
                src={
                  '/img/feature/applicant-tracking-crm/work-efficiently-02.png'
                }
                alt="work-efficiently-02"
                className="h-auto w-full hidden tablet:block"
              />
              <img
                src={
                  '/img/feature/applicant-tracking-crm/work-efficiently-02-mobile.png'
                }
                alt="work-efficiently-02"
                className="h-auto w-full tablet:hidden"
              />
            </div>
            <div className={switchTabs === 'option-3' ? '' : 'hidden'}>
              <img
                src={
                  '/img/feature/applicant-tracking-crm/work-efficiently-03.png'
                }
                alt="work-efficiently-03"
                className="h-auto w-full hidden tablet:block"
              />
              <img
                src={
                  '/img/feature/applicant-tracking-crm/work-efficiently-03-mobile.png'
                }
                alt="work-efficiently-03"
                className="h-auto w-full tablet:hidden"
              />
            </div>
          </div>
        </div>
      </LPContainer>
    </div>
  )
}

export default ApplicantTrackingCRMWorkEfficientlySection
